export const checkoutStepLabel = {
    connection: "Anschluss",
    contactAndPayment: "Kontakt & Bezahlung",
    contractSummary: "Tarif",
    orderSummary: "Übersicht",
};
